module.exports = __webpack_public_path__ + "img/loading.a538323f.gif";